// @flow
export { default } from './AnimatedSpinner';
export type { Props } from './AnimatedSpinner';



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/AnimatedSpinner/index.js